import isApiResponseShape from '@src/utils/is-api-response-shape';
import Message from '@src/components/antd/message';
import { delay } from '@src/utils/common-util';

export default function registerErrorHandler(app) {
  app.use({
    async onError(err, dispatch) {
      Message.info(err.message);

      if (err.message === 'Timeout') {
        return dispatch({
          type: 'toast/show',
          payload: { type: 'fail', message: '网络连接超时' }
        });
      }
      if (isApiResponseShape(err)) {
        if (err.code === -20005 /*没有授权*/) {
          dispatch({
            type: 'login/logoutModal'
          });
        } else {
          dispatch({
            type: 'toast/show',
            payload: { type: 'fail', message: err.message }
          });
        }
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/register-error-handler/index.js